<template functional>
  <div
    class="tabs control-tag-toggle"
    :class="[
      {
        'is-box': props.tabStyle === '1',
        'is-toggle': props.tabStyle === '2',
        'is-toggle is-toggle-rounded': props.tabStyle === '3',
      },
      data.staticClass,
      data.class
    ]"
  >
    <ul>
      <slot />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ControlTagToggle',
  props: {
    // allow choose style
    tabStyle: { type: String, default: () => '0' },
  },
}
</script>

<style lang="scss">
.control-tag-toggle {
  // fix weid conflict css when tab stay inside content class
  > ul {
    margin: 0;
    > li {
      margin-top: 0;
    }
  }

  &.is-small {
    font-weight: 500;
  }
}
</style>

